module.exports = __webpack_public_path__ + "img/banner_color.719fc7bd.png";